import wv, { getAdShieldEnabled, getHotcommentAd, getNewcommentAd } from '@cpc/comment-sdk-jsapi';
import type { SlotCallbackParamsInterface } from '@cpc/comment-sdk-types/src/sdk';
import { toRefs } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { constant } from '@cpc/comment-sdk-common';
import { scriptOnReady } from '@cpc/lib-js-require';

import { PROD_AD_SDK_JS_LINK } from '../../constants';

const getBrand = function () {
  const res = wv.getBrand();

  return res && res.code === 0 ? (res.data ? res.data.toLowerCase() : 'oppo') : 'oppo';
};

// const getInfinityDetailPage = function () {
//   const res = wv.getConfigValue('CommonConfig_infinity_detailPage');
//   const pushRes = wv.getConfigValue('CommonConfig_infinity_pushDetailPage');

//   if ((res ||pushRes) && (res.data === 1 || pushRes === 1)) {
//     return true;
//   }

//   return false;
// };

let hotPosIds: Array<string> = [];
let hotIds: Array<string> = [];
let newPosIds: Array<string> = [];
let newIds: Array<string> = [];

export const commentAdCallback = async (slotCallbackParamas: SlotCallbackParamsInterface) => {
  const {
    el, // 广告插槽 dom 节点
    index, // 当前广告插槽索引值，从0开始
    size, // 当前评论列表已加载数目(刷次*每刷条数)
    total, // 当前文章的评论总条数
    type, // 广告插槽（评论）类型 new, hot, top
    domId, // 广告插槽 dom id （选择器）
    loadCompleted, // 当前刷 广告插槽已全部加载完成，会根据type触发多次，eg: 进入页面 hot 最后一条触发一次，new 最后一条触发一次；第二刷： new 最后一条再次触发
  } = slotCallbackParamas;

  const { adConfig, pageType } = toRefs(useGlobalState());

  // 是否为oppo上划场景
  const isOppoUpwardStroke = window.BrowserNormal?.getAppHost?.() === 6 || false;

  // const isInfinity = getInfinityDetailPage();

  // 临时只开启文章页广告
  if (pageType.value !== constant.PageType.DEFAULT || isOppoUpwardStroke) {
    return;
  }

  /**
   * 无限流广告逻辑
   *  开启无限流
   *    文章页关闭广告
   *      isInfinity: true
   *      pageType.value === constant.PageType.DEFAULT
   *    文章页浮窗开启广告
   *      isInfinity: true
   *      pageType.value !== constant.PageType.DEFAULT
   *  关闭无限流
   *    文章页开启广告
   *      isInfinity: false
   *      pageType.value === constant.PageType.DEFAULT
   *    文章页浮窗关闭广告
   *      isInfinity: false
   *      pageType.value !== constant.PageType.DEFAULT
   */
  // if (pageType.value !== constant.PageType.DEFAULT && !isInfinity) {
  //   return;
  // } else if(pageType.value === constant.PageType.DEFAULT && isInfinity) {
  //   return;
  // }

  const brand = getBrand();

  const hotCommentAdPosId = Array.isArray(adConfig.value.hotCommentAdPosId)
    ? adConfig.value.hotCommentAdPosId
    : adConfig.value.hotCommentAdPosId[brand];

  const newCommentAdPosId = Array.isArray(adConfig.value.newCommentAdPosId)
    ? adConfig.value.newCommentAdPosId
    : adConfig.value.newCommentAdPosId[brand];

  const adShield = await getAdShieldEnabled();
  const isShowHotcommentAd = adShield[2];
  const isShowNewcommentAd = adShield[3];

  if (isShowHotcommentAd && type === 'hot') {
    const hotCommentAd = await getHotcommentAd();
    const { least, start, frequency } = hotCommentAd;
    const realStart = index + 1 - start;

    if (
      total > least
      && realStart >= 0
      && realStart % frequency === 0
      && hotCommentAdPosId[hotPosIds.length]
    ) {
      hotPosIds.push(hotCommentAdPosId[hotPosIds.length]);
      hotIds.push(domId);
    }
  }

  if (isShowNewcommentAd && type === 'new') {
    const newCommentAd = await getNewcommentAd();
    const { least, start, frequency } = newCommentAd;
    const realStart = index + 1 - start;

    if (
      total > least
      && realStart >= 0
      && realStart % frequency === 0
      && newCommentAdPosId[newPosIds.length]
    ) {
      newPosIds.push(newCommentAdPosId[newPosIds.length]);
      newIds.push(domId);
    }
  }

  if (loadCompleted) {
    const posIds = Array.from(new Set([...hotPosIds, ...newPosIds]));
    const ids = Array.from(new Set([...hotIds, ...newIds]));

    console.log('>>> posIds, id:', posIds, ids);

    if (!posIds.length || !ids.length) {
      return;
    }

    if (window.heyTapAdInvoke) {
      handleAdInvoke(posIds, ids);
    } else {
      scriptOnReady({
        url: window.pageData?.adSdkUrl || PROD_AD_SDK_JS_LINK,
        namespace: 'heyTapAdInvoke',
        callback: () => {
          handleAdInvoke(posIds, ids);
        },
      });
    }
  }
};

export const handleAdInvoke = async (posIds: string[], ids: string[]) => {
  const { documentMeta } = toRefs(useGlobalState());
  window
    .heyTapAdInvoke({
      posIds, // 分配的广告位id
      id: ids, // 需要渲染广告的dom id
      pageId: `${documentMeta.value.source}_${documentMeta.value.docId}`, // 必填，页面id，用于区分页面
      docId: documentMeta.value.docId, // 必填，文章内容id
      source: documentMeta.value.dataSource, // 必填，文章分发算法来源
      docSource: documentMeta.value.source, // 必填，文章内容来源
      isCommentAd: true,
    })
    .then((res) => {
      console.log('>>> heyTapAdInvoke --> res:', res); // 处理渲染的回调
    })
    .catch((err) => {
      console.log('>>> heyTapAdInvoke --> err:', err);
    })
    .finally(() => {
      hotPosIds = [];
      hotIds = [];
      newPosIds = [];
      newIds = [];
    });
}
